module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/airplane-04143f04822962ac115ad96484ba62c8.png";